import { isLocal } from '../../localId/localId';
import {
  ADD_LOCAL_SUBCONTRACTOR_TIMESHEET,
  API_CREATE_SUBCONTRACTOR_TIMESHEET,
  API_REMOVE_SUBCONTRACTOR_TIMESHEET,
  API_UPDATE_SUBCONTRACTOR_TIMESHEET,
  dirtyTimesheets,
  REMOVE_LOCAL_SUBCONTRACTOR_TIMESHEET,
  SAVE_SUBCONTRACTOR_TIMESHEET
} from './subcontractorTimesheets.reducer';

export const save = resource => ({ type: SAVE_SUBCONTRACTOR_TIMESHEET, resource });
export const add = workOrderId => ({ type: ADD_LOCAL_SUBCONTRACTOR_TIMESHEET, workOrderId });
export const remove = id => ((isLocal(id))
  ? ({ type: REMOVE_LOCAL_SUBCONTRACTOR_TIMESHEET, id })
  : ({ resourceAction: API_REMOVE_SUBCONTRACTOR_TIMESHEET, id }));

export const apiSaveDirty = () =>
  (dispatch, getState) =>
    Promise.all(dirtyTimesheets(getState()).map(resource =>
      ((isLocal(resource.id))
        ? dispatch({ resourceAction: API_CREATE_SUBCONTRACTOR_TIMESHEET, resource })
        : dispatch({ resourceAction: API_UPDATE_SUBCONTRACTOR_TIMESHEET, resource }))));



// WEBPACK FOOTER //
// ./src/reducers/workOrder/subcontractorTimesheets/subcontractorTimesheets.actions.js